exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-my-index .tab-bottom {\n  position: fixed;\n  bottom: 0;\n}\n.page-my-index .tab-bottom .link-font {\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n}\n.page-my-index .weui-bar__item_on {\n  background: #247e3b;\n}\n.page-my-index .weui-tabbar__item.weui-bar__item_on .weui-tabbar__icon,\n.page-my-index .weui-tabbar__item.weui-bar__item_on .weui-tabbar__icon > i,\n.page-my-index .weui-tabbar__item.weui-bar__item_on .weui-tabbar__label {\n  color: #fff !important;\n}\n.page-my-index .vux-badge-single {\n  margin-left: 5px;\n}\n.page-my-index .vux-badge {\n  margin-left: 3px;\n  margin-top: -18px;\n}\n", ""]);

// exports
